import { toPercent } from '@utils/Format'
import { getBenchmarkStats } from '@modules/consolidator/utils/get-benchmark-stats/get-benchmark-stats'
import { CLIENT_BENCHMARK_KEY } from '@utils/clienteBenchmark'

const DEFAULT_VALUE = '-'

const PERIOD_KEYS = ['dia', 'mes', 'ano', '12M', '24M', '36M', 'inicio']

const BENCHMARK_FIELD_BY_PERIOD = {
  dia: 'rent_dia',
  mes: 'rent_mes',
  ano: 'rent_ano',
  '12M': 'rent_12M',
  '24M': 'rent_24M',
  '36M': 'rent_36M',
  inicio: 'rent_inicio',
}

export const formatRentBenchmarkTable = (
  walletAnalysis,
  { benchmarks = [] } = {}
) => {
  const stats = walletAnalysis && walletAnalysis.portfolio_statistics
  if (!stats) {
    return {
      rentabilidadesAll: buildEmptyRentabilidadesAll(),
      rentabilidadesBenchmarks: {},
    }
  }
  return {
    rentabilidadesAll: {
      rentabilidade: extractPeriodMap(stats, ''),
      rentabilidade_relativo: extractPeriodMap(stats, '_relativo'),
      benchmark_relativo: stats.benchmark_relativo || null,
      benchmark_relativo_nome: stats.benchmark_relativo_nome || null,
      ipca: extractPeriodMap(stats, '_ipca'),
      data_inicio: stats.data_inicio || null,
      data_fim: stats.data_fim || null,
    },
    rentabilidadesBenchmarks: extractBenchmarks(stats, benchmarks),
  }
}

const buildEmptyRentabilidadesAll = () => ({
  rentabilidade: {},
  rentabilidade_relativo: {},
  benchmark_relativo: null,
  benchmark_relativo_nome: null,
  ipca: {},
  data_inicio: null,
  data_fim: null,
})

const extractPeriodMap = (stats, suffix) => {
  const map = {}
  for (const period of PERIOD_KEYS) {
    const sourceKey = suffix ? `${period}${suffix}` : period
    map[period] = formatPercent(stats[sourceKey])
  }
  return map
}

const extractBenchmarks = (stats, benchmarks) => {
  const raw = stats.benchmarks_statistics || {}
  const result = {}
  for (const bench of benchmarks) {
    if (!bench) continue
    const data = getBenchmarkStats(raw, bench)
    if (!data) continue
    result[bench.id] = formatBenchmarkRow(data)
  }
  if (raw[CLIENT_BENCHMARK_KEY]) {
    result[CLIENT_BENCHMARK_KEY] = formatBenchmarkRow(raw[CLIENT_BENCHMARK_KEY])
  }
  return result
}

const formatBenchmarkRow = (data) => {
  const formatted = {}
  for (const period of PERIOD_KEYS) {
    const field = BENCHMARK_FIELD_BY_PERIOD[period]
    formatted[period] = formatPercent(data[field])
  }
  return formatted
}

const formatPercent = (value) => {
  if (value === null || value === undefined) return DEFAULT_VALUE
  if (typeof value !== 'number' || !Number.isFinite(value)) return DEFAULT_VALUE
  return toPercent(value * 100)
}
